import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private httpClient: HttpClient,
    private router: Router
  ) { }

  public assignments(): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/assignments/public`);
  }

  public assignment(assignmentId: number): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/assignments/public/${assignmentId}`);
  }

  public city(cityId: string | null): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/cities/public/${cityId}`);
  }

  public organizations(): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/organizations`);
  }

  cityByCoordinates(lat: number, long: number, organizationId: number | null): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/organizations/by-coordinates`, { params: new HttpParams({ fromObject: { lat, long, organization_id: organizationId || '' } }) });
  }

  organizationId() {
    if (environment.country_selector && localStorage.getItem('organization')) {
      return Number(localStorage.getItem('organization'))
    }

    else {
      console.log('Organization ID asked before location is set')
      return 0
    }
  }

  apiUrl() {
    if(environment.production == false) {
      return environment.master_url
    }
    
    if (localStorage.getItem('api_url')) {
      return localStorage.getItem('api_url') as string
    }

    else {
      console.log('apiUrl called prematurely')
      return 
    }
  }

  wsUrl() {
    if(environment.production == false) {
      return environment.master_ws_url
    }
    
    if (localStorage.getItem('ws_url')) {
      return localStorage.getItem('ws_url')
    }

    else{
      console.log('wsUrl called prematurely')
      return
    }
  }
}
